import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageService } from 'src/app/models/PageService';
import { PageServiceService } from '../service/page-service.service';
import {MenuUtil, SERVICE_URL} from "../../utils/menu-utils";
import {Subscription} from "rxjs";
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-messervices',
  templateUrl: './messervices.component.html',
  styleUrls: ['./messervices.component.scss'],
})
export class MesservicesComponent implements OnInit, OnDestroy {

  contentHtml: SafeHtml;
  /**Spinner Status */
  progressSpinner: boolean = false;
  spinner: boolean = true;
  public item: PageService = null;
  private hiddenId : string;
  private subscription : Subscription;
  private santeClairSubscription : Subscription;

  constructor(private readonly route: ActivatedRoute, private router: Router,
    private readonly api: PageServiceService,private messageService: MessageService,private translateService: TranslateService) {
  }

  getPageService(id: string) {
    this.spinner = true;
    this.progressSpinner = true;
    this.api.getPageServiceById(id).subscribe({
      next: item => {
        this.item = item;
        this.contentHtml = this.item.contentHtml;
        this.spinner = false;
      },
      error: error => {
        console.log(error);
        this.spinner = false;
      }
    });
  }

  ngOnInit() {
    this.subscription = MenuUtil._menuIdSubject$.asObservable().subscribe({
      next: (value) => {
        this.hiddenId = value.id;
        if(value.url === SERVICE_URL || value.routerLink === SERVICE_URL)
          this.getPageService(this.hiddenId);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.santeClairSubscription?.unsubscribe();
  }

  onLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      if(target.id == 'sante-clair-btn'){
        this.spinner = true;
        event.preventDefault();
        this.santeClairSubscription = this.api.authenticationSanteclair(target.className).subscribe({
          next: (response) => {
            if (response) {
              const url = response.location;
              if (url) {
                window.open(url, '_blank');
              }
            }
            this.spinner = false;
          },
          error: (err) => {
            this.spinner = false;
            this.messageService.add({
              key: 'error', severity: 'error',
              summary: this.translateService.instant('services.toast.error-summary'),
              detail: this.translateService.instant('services.toast.error-detail')
            });
          }
        });
      }
    }
  }

}
